import React from 'react';
import { Button, CircularProgress } from '@mui/material';

/**
 * SubmitButton - one pending state for every form (design.md §5.4).
 *
 * Keeps the label visible and puts the spinner beside it, so the button does not
 * change width or lose its meaning mid-submit. Disabled while pending, which
 * also blocks double submits.
 *
 * Props:
 *  - pending      : show the spinner and disable the button
 *  - pendingLabel : optional label swap while pending, e.g. "Saving…"
 *  - startIcon    : replaced by the spinner while pending
 *  - everything else passes through to Button
 */
const SubmitButton = ({
  pending = false,
  pendingLabel,
  disabled,
  startIcon,
  children,
  type = 'submit',
  variant = 'contained',
  ...buttonProps
}) => (
  <Button
    type={type}
    variant={variant}
    disabled={disabled || pending}
    startIcon={pending ? <CircularProgress size={16} color="inherit" /> : startIcon}
    {...buttonProps}
  >
    {pending && pendingLabel ? pendingLabel : children}
  </Button>
);

export default SubmitButton;
